import type {
  InfoDownloadApiQuery,
  PaymentReceiptApi,
  PaymentReceiptsListQuery,
  PaymentReceiptsSummaryApi,
  PaymentReceiptsSummaryApiQuery,
  PaymentReceiptDownloadLinkApi,
  CustomerWithPaymentReceiptsApi,
} from "@/Modules/Models/Api/PaymentReceipt";
import type { PaginatedApiResponse } from "@/Modules/App/Models/Api/PaginatedApiResponse";

import { get2, post2 } from "./utils/FunctionalTherapyApi";

export function getPaymentReceiptsSummary(
  paymentReceiptsSummaryParams: PaymentReceiptsSummaryApiQuery
): Promise<PaymentReceiptsSummaryApi> {
  return get2<PaymentReceiptsSummaryApiQuery, PaymentReceiptsSummaryApi>("v1.0/payment-receipts-summary", {
    customer_uuid: paymentReceiptsSummaryParams.customer_uuid,
    customer_name: paymentReceiptsSummaryParams.customer_name,
  });
}

export function getPaymentReceiptsList(
  PaymentReceiptsListQuery: PaymentReceiptsListQuery
): Promise<PaginatedApiResponse<PaymentReceiptApi>> {
  return get2<PaymentReceiptsListQuery, PaginatedApiResponse<PaymentReceiptApi>>(
    "v1.0/payment-receipts",
    PaymentReceiptsListQuery,
    undefined,
    { raw: true }
  );
}

export function getCustomersWhithPaymentReceiptsList(): Promise<CustomerWithPaymentReceiptsApi[]> {
  return get2<void, CustomerWithPaymentReceiptsApi[]>("v1.0/payment-receipts-customers");
}

export function downloadPaymentReceipts(infoDownload: InfoDownloadApiQuery): Promise<string> {
  return post2<InfoDownloadApiQuery, string>("v1.0/payment-receipts/download", infoDownload);
}

export function getPaymentReceiptDownloadLink(
  paymentReceiptUuid: string
): Promise<PaymentReceiptDownloadLinkApi> {
  return get2<string, PaymentReceiptDownloadLinkApi>(`v1.0/payment-receipts/${paymentReceiptUuid}/pdf`);
}
